const PaymentTerms = {

    // FIELDS
    "name": "اسم",
    "description": "وصف",
    "status": "الحالة",
    "search": "بحث",

    // PAGE HEADER
    "payment_terms": "شروط الدفع",

    // ERROR
    "error_name": "أدخل الاسم",
    "error_desc": "أدخل الوصف",
    "error_status": "اختر الحالة",

    // TABLE HEADER
    "table_name": "اسم",
    "table_description": "وصف",
    "table_status": "حالة",

}

export default PaymentTerms;